<template>
  <sModal
    :title="mutableItem && mutableItem.id ? $t('AIRequirements.EditAIRequirement') : $t('AIRequirements.AddAIRequirement')"
    :value="open"
    @close="closeModal">
    <template #activator>
      <slot
        name="activator"/>
    </template>
    <sForm
      v-if="mutableItem"
      ref="aiRequirementForm"
      label-position="top"
      :model="mutableItem"
      :rules="rules">
      <sFormItem
        data-qa="input-ai-requirement-title"
        :label="$t('AIRequirements.AIRequirement')"
        prop="title">
        <sInput
          clearable
          :max-length="4000"
          max-rows="10"
          rows="4"
          type="textarea"
          :value.sync="mutableItem.title"/>
      </sFormItem>
      <sFormItem
        v-for="(contentItem, index) in mutableItem.contents"
        :key="`content-item-${index}`"
        :data-qa="`input-ai-requirement-content-${index}`"
        :label="contentItem.label || `${$t('AIRequirements.AIRequirement')} ${index + 1}`"
        :prop="`contents.${index}.value`">
        <sInput
          clearable
          :max-length="4000"
          max-rows="10"
          rows="4"
          type="textarea"
          :value.sync="contentItem.value"/>
      </sFormItem>
    </sForm>
    <div
      key="footer"
      slot>
      <sButton
        data-qa="btn-ok-dialog"
        type="black"
        @click="sendOk">
        {{ $t('Common.Save') }}
      </sButton>
      <sButton
        data-qa="btn-close-dialog"
        type="text"
        @click="closeModal">
        {{ $t('Common.Cancel') }}
      </sButton>
    </div>
  </sModal>
</template>
<script>

export default {
  name: 'AiRequirementsAdded',
  data() {
    return {
      mutableItem: null,
      rules: {}
    }
  },
  methods: {
    closeModal() {
      this.$emit('update:open', false)
    },
    sendOk() {
      this.$refs.aiRequirementForm.validate()
        .then((valid) => {
          if (!valid) {
            return
          }
          this.$emit('ok', this.mutableItem)
          this.closeModal()
        })
        .catch(() => {})
    },
    createRulesForContents() {
      const baseRules = [
        { required: true, message: this.$t('Validate.Required'), trigger: 'blur' },
        { max: 4000, message: this.$t('Validate.maxLength', {number: 4000, type: this.$tc('Common.characters', 10) }), trigger: 'blur' },
        { min: 2,  message: this.$t('Validate.minLength', {number: 2, type: this.$tc('Common.characters', 2) }), trigger: 'blur' },
      ]
      this.$set(this, 'rules', {})
      this.$set(this.rules, 'title', [ ...baseRules ])
      this.mutableItem.contents.forEach((contentItem, index) => {
        this.$set(this.rules, `contents.${index}.value`, [ ...baseRules ])
      })
    }
  },
  watch: {
    open(newVal) {
      if (newVal) {
        this.mutableItem = this.item
        this.createRulesForContents()
      }
    }
  },
  created() {},
  props: {
    tender: {
      type: Object,
      required: true
    },
    item: {
      type: Object,
    },
    open: {
      type: Boolean
    }
  },
}
</script>
<style scoped>

</style>